import React, { useEffect, useState, useContext, Component } from "react";

import { AccountContext } from "../../provider/account";
import PlaylistService from "../../service/playlist-service";
import Error from "../../module/views/error";
import Loading from "../../module/views/loading";

import View from "./view";

const STATUS = { LOADING: 1, ERROR: 2, SUCCESS: 3 };

export default ({ onSelect }) => {
  const [status, setStatus] = useState(STATUS.LOADING);
  const [playlists, setPlaylists] = useState([]);
  const [userInfo] = useContext(AccountContext);

  const fetchPlaylists = async () => {
    const p = await PlaylistService.getAllPlaylist({
      username: userInfo.isLoggedIn ? userInfo.username : "",
    });
    if (p) {
      setPlaylists(p);
      setStatus(STATUS.SUCCESS);
    } else {
      setStatus(STATUS.ERROR);
    }
  };

  useEffect(() => {
    fetchPlaylists();
  }, []);

  switch (status) {
    case STATUS.LOADING:
      return <Loading />;
    case STATUS.SUCCESS:
      if (playlists && playlists.length > 0)
        return <View playlists={playlists} onSelect={onSelect} />;
      return <Error message="You have not created any playlist" />;
    case STATUS.ERROR:
      return <Error message="You have not created any playlist" />;
  }
};
